/* ++++++++++ --------------- EXPORT : DATA AVERAGE INVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
    averageinview:{
        
    }
});
